import { Link } from 'react-router-dom';
import { Icon } from './Icon';

export interface Crumb {
  label: string;
  to?: string;
}

/** Breadcrumb in reading order (RTL): home first, current page last. */
export function Breadcrumb({ items }: { items: readonly Crumb[] }) {
  return (
    <nav aria-label="مسیر صفحه" data-testid="breadcrumb">
      <ol className="flex items-center gap-1 text-caption text-ink-faint">
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1">
              {index > 0 ? (
                <Icon name="chevron-left" size={12} className="text-surface-strong" />
              ) : null}
              {item.to && !last ? (
                <Link to={item.to} className="link">
                  {item.label}
                </Link>
              ) : (
                <span
                  className={last ? 'text-ink-dim' : undefined}
                  aria-current={last ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
